import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Donadornt = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className='container transparencia-container'>
            <div className='row'>
                <div className='col-12'>
                    <div className='transparencia_title'>
                        <h1>El Proceso de Transplante</h1>
                        <hr className="tramitehr" />
                    </div>
                    <div className="row">
          <div className="col-12" >
<div class="accordion" id="accordionConoce">
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingOne">
      <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
        1) ¿Cuando se requiere un transplante?
      </button>
    </h2>
    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Al ser valorado por un médico que diagnostique una falla irreversible de un órgano (riñón, hígado, corazón) o lesión de un tejido (corneas, piel huesos), así como el perfecto entendimiento del paciente acerca de su condición.
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingTwo">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
        2) Consulta externa de "Transplantes"
      </button>
    </h2>
    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Mediante una hoja de referencia, el médico tratante deberá canalizar al paciente con insuficiencia a un establecimiento que cuente con Licencia para llevar a cabo procesos de Trasplante.          
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingThree">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
        3) Protocolo de Estudio para Transplante
      </button>
    </h2>
    <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      El equipo de trasplante volverá a explicar el diagnóstico al paciente y si es candidato a la realización de un trasplante, se iniciará un protocolo, que consiste en una serie de estudios de Laboratorio y gabinete para que sea valorado por diferentes especialistas y confirmar que se está en condiciones para recibir un órgano o tejido. Además de una valoración por parte de los servicios de Psicología y Trabajo Social.
      </div>
    </div>
  </div>
    <div class="accordion-item">
    <h2 class="accordion-header" id="headingFour">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
        4) Presentación de Caso a "Comité Interno de Transplante"
      </button>
    </h2>
    <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Una vez realizado el protocolo, el caso clínico del paciente es presentado ante el “Comité Interno de Trasplantes” del Hospital el cual está conformado por un grupo de especialistas en el tema y aprobara la realización del trasplante.
      </div>
    </div>
  </div>
      <div class="accordion-item">
    <h2 class="accordion-header" id="headingFive">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapsefive">
        5) Registro de Espera
      </button>
    </h2>
    <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Con la aprobación del comité, el Coordinador hospitalario de donación podrá ingresar al paciente en el Registro de Espera del hospital. Y a la vez es registrado en un sistema a nivel Nacional (Sistema informático de Registro Nacional de Trasplante)* otorgándose un comprobante del registro.
      *Es muy importante que si estas registrado en otro Hospital solicites la baja de su registro ya que no puedes estar inscrito en el registro de más Hospitales.
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingSix">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
        6) Donación
      </button>
    </h2>
    <div id="collapseSix" class="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Ahora, para que continúe el proceso dependemos de la generosidad de las personas para donar órganos. Mientras se debe acudir mensualmente al 
      Hospital para valorar:
      <ul>
       <li>Que no haya infección activa</li>
       <li>Hospitalizaciones recientes</li>
       <li>Transfusión Sanguínea reciente</li>
       <li>Laboratorios de Control</li>
       <li>Acudir a dejar muestra a Seroteca. Para cuando haya un posible donante se pueda realizar la prueba de compatibilidad.</li>
       </ul>
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingSeven">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
        7) Asignación de un órgano
      </button>
    </h2>
    <div id="collapseSeven" class="accordion-collapse collapse" aria-labelledby="headingSeven" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Una vez ocurrida una DONACIÓN los órganos y tejidos obtenidos serán asignados por parte del comité Interno del Hospital Donador de acuerdo al Art.- 336 de la Ley General de Salud.
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingEight">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
        8) Hospitalización y Transplante
      </button>
    </h2>
    <div id="collapseEight" class="accordion-collapse collapse" aria-labelledby="headingEight" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Asignado el órgano o tejido el paciente receptor es citado al hospital para su internamiento y realización del Trasplante.   
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingNine">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
        9) Seguimiento
      </button>
    </h2>
    <div id="collapseNine" class="accordion-collapse collapse" aria-labelledby="headingNine" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Una vez trasplantado el paciente deberá acudir periódicamente (de acuerdo a las indicaciones médicas) para valoración.  
      </div>
    </div>
  </div>

</div>
          </div>
      </div>

                </div>
            </div>

        </div>
    )
}

export default Donadornt
